import type { FC, MouseEventHandler } from 'react';
import { useState } from 'react';
import icons from '@icons';
import { Picture } from '@ui';
import type { IconType } from '@root/src/types';
import './styles.scss';

const {
  chevronLeft: {
    white: chevronLeftWhite,
    lightGrey: chevronLeftLg,
    red: chevronLeftRed,
    darkGrey: chevronLeftDG
  },
  chevronRight: {
    white: chevronRightWhite,
    lightGrey: chevronRightLg,
    red: chevronRightRed,
    darkGrey: chevronRightDG
  }
} = icons.Outline;

interface ArrowCircleProps {
  onClick?: MouseEventHandler;
  left?: boolean;
  className?: string;
  disabled?: boolean;
  white?: boolean;
}

const getIcon = (
  left: boolean,
  white: boolean,
  disabled: boolean
): IconType => {
  if (left) {
    if (white) return chevronLeftWhite;
    if (disabled) return chevronLeftLg;
    return chevronLeftDG;
  }
  if (white) return chevronRightWhite;
  if (disabled) return chevronRightLg;
  return chevronRightDG;
};

const ArrowCircle: FC<ArrowCircleProps> = ({
  onClick,
  left = false,
  white = false,
  className,
  disabled = false
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`arrow-circle ${
        left ? 'arrow-circle--left' : 'arrow-circle--right'
      } ${className || ''} ${disabled ? 'arrow-circle--disabled' : ''}`}
      onClick={disabled ? undefined : onClick}
      onMouseEnter={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
    >
      <Picture
        height='32'
        icon={
          isHovered && !disabled
            ? left
              ? chevronLeftRed
              : chevronRightRed
            : getIcon(left, white ?? false, disabled)
        }
      />
    </div>
  );
};

export default ArrowCircle;
